import '@babel/polyfill'
import './plugins/vuetify'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'

import Header from './components/Header'
import Navigation from './components/Navigation'
import MenuNav from './components/MenuNav.vue'
import GlobalDate from './components/GlobalDate'
import GlobalMonth from './components/GlobalMonth'
import Loading from './components/Loading.vue'
import templatePlugin from '@/plugins/vuetify'
import AlertBox from './components/AlertBox'

Vue.config.productionTip = false
Vue.use(templatePlugin)

Vue.component(Header.name, Header)
Vue.component(Navigation.name, Navigation)
Vue.component(MenuNav.name, MenuNav)
Vue.component(GlobalDate.name, GlobalDate)
Vue.component(GlobalMonth.name, GlobalMonth)
Vue.component(Loading.name, Loading)
Vue.component(AlertBox.name, AlertBox)

let counter = 0
axios.interceptors.request.use(function (config) {
  counter++
  store.state.loading2.show() // vuex mutation set loading state to true
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config) {
  counter--
  if (counter === 0) {
    store.state.loading2.dialog = false // vuex mutation set loading state to false
  }
  return config
}, function (error) {
  counter--
  if (counter === 0) {
    store.state.loading2.dialog = false // vuex mutation set loading state to false
  }
  // store.state.loading2.dialog = false
  return Promise.reject(error)
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
